import { render, staticRenderFns } from "./LabelSizeSelector.vue?vue&type=template&id=44955c52&"
import script from "./LabelSizeSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports